import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { ALERT } from "../actionTypes";

// Categories this centre is allowed to post a blog in (plus an access flag).
export const getCenterBlogCategories = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("centerToken");
    const response = await dispatch(getDataAPI("center/blog/categories", token));
    return response.data.data; // { access, categories }
  } catch (error) {
    return { access: false, categories: [] };
  }
};

// This centre's own blogs (paginated).
export const getCenterBlogs = (page = 1) => async (dispatch) => {
  try {
    const token = localStorage.getItem("centerToken");
    const response = await dispatch(
      getDataAPI(`center/blog/list?page=${page}`, token)
    );
    return response.data.data;
  } catch (error) {
    return null;
  }
};

// Submit a blog for council approval.
export const addCenterBlog = (data) => async (dispatch) => {
  try {
    dispatch({ type: ALERT, payload: { loading: true } });
    const token = localStorage.getItem("centerToken");
    const response = await dispatch(
      postDataAPI("center/blog/create", data, token)
    );
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: { success: response.data.message || "Blog submitted" },
    });
    return response.data;
  } catch (error) {
    dispatch({ type: ALERT, payload: { loading: false } });
    dispatch({
      type: ALERT,
      payload: {
        error:
          error.response?.data?.message || "Could not submit the blog. Try again.",
      },
    });
    return null;
  }
};
